import React from 'react';
import Header from './Header';
import Order from './Order';
import Inventory from './Inventory';
import Fish from './Fish';
import sampleFishes from '../sample-fishes';
import base from '../base';

class App extends React.Component {

	constructor() {
		super();

		this.addFish     = this.addFish.bind( this );
		this.updateFish  = this.updateFish.bind( this );
		this.removeFish  = this.removeFish.bind( this );
		this.loadSamples = this.loadSamples.bind( this );
		this.addToOrder  = this.addToOrder.bind( this );
		this.removeFromOrder = this.removeFromOrder.bind( this );

		// Set the initial state of our app
		this.state = {
			fishes: {},
			order: {}
		};
	}

	/**
	 * Special react.js life cycle method
	 * Runs before the <App> is rendered.
	 * Sync state with Firebase data before application loads
	 * @see https://reactjs.org/docs/react-component.html#componentwillmount
	 */
	componentWillMount() {
		this.ref = base.syncState( `${this.props.params.storeId}/fishes`, {
			context: this,
			state: 'fishes'
		} );

		// Check if there is any order in localstorage
		const localStorageRef = localStorage.getItem( `order-${this.props.params.storeId}` );

		if ( localStorageRef ) {

			// Update our App component's order state
			this.setState( {
				order: JSON.parse( localStorageRef )
			} );

		}
	}

	/**
	 * Special react.js life cycle method
	 * @see https://reactjs.org/docs/react-component.html#componentWillUnmount
	 */
	componentWillUnmount() {
		base.removeBinding( this.ref );
	}

	/**
	 * Special react.js life cycle method
	 * @see https://reactjs.org/docs/react-component.html#componentWillUpdate
	 */
	componentWillUpdate( nextProps, nextState ) {
		localStorage.setItem( `order-${this.props.params.storeId}`, JSON.stringify( nextState.order ) );
	}

	addFish( fish ) {
		// Update our state
		const fishes = {...this.state.fishes};
		// Add in our new fish
		const timestamp = Date.now();
		fishes[`fish-${timestamp}`] = fish;
		// set state
		this.setState({ fishes });
	}

	updateFish( key, updatedFish ) {
		const fishes = {...this.state.fishes};
		fishes[key] = updatedFish;
		this.setState({ fishes });
	}

	removeFish( key ) {
		const fishes = {...this.state.fishes};
		fishes[key] = null;
		this.setState({ fishes });
	}

	loadSamples() {
		this.setState({
			fishes: sampleFishes
		});
	}

	addToOrder( key ) {
		// Take a copy of our state
		const order = {...this.state.order};
		// Update or add the new number of fish ordered
		order[key] = order[key] + 1 || 1;
		// Update our state
		this.setState({ order });
	}

	removeFromOrder( key ) {
		// Take a copy of our state
		const order = {...this.state.order};
		delete order[key];
		// Update our state
		this.setState({ order });
	}

	render() {
		return (
			<div className="catch-of-the-day">
				<div className="menu">
					<Header age="5000" cool={true} tagline="Fresh Seafood Market" />
					<ul className="list-of-fishes">
						{
							Object
								.keys( this.state.fishes )
								.map( key => <Fish key={key} index={key} details={this.state.fishes[key]} addToOrder={this.addToOrder} /> )
						}
					</ul>
				</div>
				<Order
					fishes={this.state.fishes}
					order={this.state.order}
					params={this.props.params}
					removeFromOrder={this.removeFromOrder}
				/>
			<Inventory
				addFish={this.addFish}
				loadSamples={this.loadSamples}
				fishes={this.state.fishes}
				updateFish={this.updateFish}
				removeFish={this.removeFish}
				storeId={this.props.params.storeId}
			/>
			</div>
		)
	}

}

App.propTypes = {
	params: React.PropTypes.object.isRequired
};

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/